import React from 'react';
import { Handle, Position } from 'reactflow';
import { Image, EyeOff } from 'lucide-react';
import './NodeStyles.css';

const MediaNode = ({ id, data, selected }) => {
    const isShow = data.show !== false;
    const stimulusId = data.stimulus_id || '';
    const mediaSrc = data.media?.src || '';

    // Derive a short label for the media URL
    const urlLabel = (() => {
        if (!mediaSrc) return 'No source set';
        try {
            const u = new URL(mediaSrc);
            const path = u.pathname.split('/').pop() || u.hostname;
            return path.length > 28 ? path.slice(0, 25) + '…' : path;
        } catch (_) {
            return mediaSrc.length > 28 ? mediaSrc.slice(0, 25) + '…' : mediaSrc;
        }
    })();

    const handleDoubleClick = (e) => {
        e.stopPropagation();
        // Open the node editor panel (same pattern as QuestionNode)
        try {
            window.dispatchEvent(new CustomEvent('graph-center-node', { detail: { nodeId: id } }));
        } catch (_) { }
    };

    return (
        <div
            className={`question-node media-node ${isShow ? 'media-show' : 'media-hide'} ${selected ? 'selected' : ''}`}
            onDoubleClick={handleDoubleClick}
            title={data.wfTooltip || `Media: ${isShow ? 'Show' : 'Hide'} ${stimulusId}`}
        >
            <Handle
                type="target"
                position={Position.Top}
                className="node-handle node-handle-top"
            />

            <div className="node-header media-header">
                <div className="node-icon">
                    {isShow
                        ? <Image size={14} strokeWidth={1.5} />
                        : <EyeOff size={14} strokeWidth={1.5} />
                    }
                </div>
                <div className="node-id">
                    {data.id || id}
                </div>
                <span className="node-type-badge media-badge">
                    {isShow ? 'SHOW' : 'HIDE'}
                </span>
            </div>

            <div className="node-content media-content">
                {stimulusId && (
                    <div className="media-stimulus-id">
                        {stimulusId}
                    </div>
                )}

                {isShow && mediaSrc && (
                    <div className="media-preview-row">
                        <img
                            className="media-thumbnail"
                            src={mediaSrc}
                            alt={data.alt || stimulusId || 'media preview'}
                            onError={(e) => { e.target.style.display = 'none'; }}
                        />
                    </div>
                )}

                <div className="media-url-label" title={mediaSrc || undefined}>
                    {urlLabel}
                </div>
            </div>

            <Handle
                type="source"
                position={Position.Bottom}
                className="node-handle node-handle-bottom"
            />
        </div>
    );
};

export default MediaNode;
